"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftStore = void 0;
class ShiftStore {
    data;
    constructor() {
        this.data = {};
    }
    add(slot) {
        this.data[slot.getId()] = slot;
    }
    byId(id) {
        return this.data[id];
    }
    query(options) {
        return Object.values(this.data).filter(s => {
            if (options.startDateMax) {
                const maxStart = options.startDateMax.valueOf();
                if (s.getStartDate().valueOf() >= maxStart) {
                    return false;
                }
            }
            if (options.startDateMin) {
                const minstart = options.startDateMin.valueOf();
                if (s.getStartDate().valueOf() < minstart) {
                    return false;
                }
            }
            if (options.repeatTemplateId) {
                if (s.getId().split("-")[0] != options.repeatTemplateId) {
                    return false;
                }
            }
            return true;
        });
    }
    delete(id) {
        if (!this.data[id]) {
            return;
        }
        delete this.data[id];
    }
}
exports.ShiftStore = ShiftStore;
